export default __webpack_public_path__ + "static/media/filter_feedback.fae95dfb.svg";